import { StoreManagementItemDTO } from "@/common/api";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class StoreModule extends VuexModule {
  public item: StoreManagementItemDTO = null;

  @Mutation
  public setItem(item: StoreManagementItemDTO): void {
    this.item = item;
  }

  @Action
  public updateItem(item: StoreManagementItemDTO) {
    this.context.commit("setItem", item);
  }
}
